import { X, Check } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const LOOP = [
  "Endless tutorials, zero shipped work",
  "Software buttons without taste or intent",
  "No briefs, no deadlines, no clients",
  "A portfolio of homework nobody hired for",
];

const STANDARD = [
  "Real briefs with real commercial stakes",
  "Direction first — tools serve the idea",
  "Deadlines, revisions and client sign-off",
  "A showreel agencies actually respond to",
];

export const NotEnough = () => (
  <section data-testid="software-not-enough-section" className="bg-ink border-y border-line py-28 sm:py-40">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <SectionHead num="04" eyebrow="The Problem" title="Learning software is not enough" />

      <Reveal className="max-w-2xl mb-14">
        <p className="text-base sm:text-lg text-smoke leading-relaxed">
          Anyone can learn where the buttons are. Agencies hire people who know <span className="text-cream">why</span> to
          press them — taste, direction, and the discipline to deliver under pressure.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-line border border-line">
        <Reveal className="bg-obsidian p-8 sm:p-12">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-dim">The Tutorial Loop</span>
          <ul className="mt-8 space-y-5">
            {LOOP.map((t, i) => (
              <li key={t} className="flex items-start gap-4">
                <X className="w-4 h-4 mt-1 text-dim shrink-0" strokeWidth={1.5} />
                <span className="font-head text-lg sm:text-xl text-smoke uppercase tracking-tight">
                  <span className="font-mono text-[10px] text-dim mr-3">0{i + 1}</span>
                  {t}
                </span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.15} className="bg-surface p-8 sm:p-12 relative overflow-hidden">
          <div className="absolute top-0 left-0 right-0 h-1 bg-acid" />
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-acid">The PARA//EL Standard</span>
          <ul className="mt-8 space-y-5">
            {STANDARD.map((t, i) => (
              <li key={t} className="flex items-start gap-4">
                <Check className="w-4 h-4 mt-1 text-acid shrink-0" strokeWidth={2} />
                <span className="font-head text-lg sm:text-xl text-cream uppercase tracking-tight">
                  <span className="font-mono text-[10px] text-acid mr-3">0{i + 1}</span>
                  {t}
                </span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);
